import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

/**
 * Subtle "Have a question? See FAQs" chip used inline on feature cards.
 *
 * Clicking the chip routes the user to the FAQs tab AND deep-links to the
 * relevant category accordion (e.g. /dashboard/faqs#net-worth). InvestorFAQs
 * reads the URL hash on mount + on hashchange, auto-expands the matching
 * category, and scrolls it into view.
 *
 * Props:
 *   categoryKey  — one of the keys in faqs/faqData.js (e.g. 'net-worth').
 *   label        — optional override for the chip text. Defaults to the
 *                  standard "Have a question? See FAQs" phrasing.
 *   className    — optional extra classes to position the chip in context.
 */
export default function FAQLink({ categoryKey, label, className = '' }) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/dashboard/faqs#${categoryKey}`);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 text-[11px] text-slate-500 hover:text-emerald-700 transition-colors group ${className}`}
      data-testid={`faq-link-${categoryKey}`}
    >
      <HelpCircle className="w-3 h-3 shrink-0" />
      <span className="underline-offset-2 group-hover:underline">
        {label || 'Have a question? See FAQs'}
      </span>
    </button>
  );
}
